import * as RxAccordion from '@radix-ui/react-accordion';
import { ReactNode } from 'react';
import { type VariantProps, tv } from 'tailwind-variants';

import ChevronRightIcon from '@cartwhl/ui/icons/ChevronRightIcon';

import Text from '../base/Text';
import './Accordion.css';

export default function Accordion({
  children,
  defaultValue,
}: {
  children: ReactNode;
  defaultValue?: string[];
}) {
  return (
    <RxAccordion.Root
      type="multiple"
      defaultValue={defaultValue}
      className="flex flex-col gap-2"
    >
      {children}
    </RxAccordion.Root>
  );
}

const trigger = tv({
  base: 'accordion-trigger flex w-full items-center justify-between gap-2 rounded-lg px-2 data-[state=closed]:h-[42px] data-[state=open]:py-3',
  variants: {
    isCurrentJob: {
      true: 'bg-blue text-white',
      false:
        'dark:hover:bg-gray-75 dark:data-[state=open]:bg-gray-75 hover:bg-gray-15 data-[state=open]:bg-gray-15',
    },
  },
});

Accordion.Item = function Item({
  children,
  triggerText,
  value,
  additionalElement,
  isCurrentJob,
}: {
  children: ReactNode;
  triggerText: string;
  value: string;
  additionalElement?: ReactNode;
  isCurrentJob?: boolean;
}) {
  return (
    <RxAccordion.Item value={value} className="w-full">
      <RxAccordion.Header className="w-full">
        <RxAccordion.Trigger className={trigger({ isCurrentJob })}>
          <ChevronRightIcon
            className={`accordion-chevron flex-none transition-transform ${
              isCurrentJob ? 'text-white' : 'text-gray-45'
            }`}
          />
          <Text
            variant="studio/body/medium/sm"
            className="accordion-title mr-auto min-w-0 text-left"
          >
            {triggerText}
          </Text>
          <div>{additionalElement}</div>
        </RxAccordion.Trigger>
      </RxAccordion.Header>
      <RxAccordion.Content className="py-2">{children}</RxAccordion.Content>
    </RxAccordion.Item>
  );
};
